"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var browser_1 = require("@sentry/browser");
var Accordion_1 = require("./Accordion");
var BrandColors_1 = __importDefault(require("./BrandColor/BrandColors"));
var BrandFonts_1 = __importDefault(require("./BrandFonts/BrandFonts"));
var BrandFontsHeader_1 = __importDefault(require("./BrandFonts/BrandFontsHeader"));
var StylePermissions_1 = __importDefault(require("../Permissions/StylePermissions/StylePermissions"));
var StylePermissionsPreview_1 = __importDefault(require("../Permissions/StylePermissionsPreview/StylePermissionsPreview"));
var BrandSetup = function (_a) {
    var brandStore = _a.brandStore, stylePermissionStore = _a.stylePermissionStore, uploadStore = _a.uploadStore, fontService = _a.fontService, explorePlans = _a.explorePlans, usingFeature = _a.usingFeature;
    return (react_1.default.createElement("div", { className: "brand-setup" },
        react_1.default.createElement(Accordion_1.Accordion, { expanded: ["color-setup"] },
            react_1.default.createElement("div", { id: "color-setup" },
                react_1.default.createElement("div", { className: "brand-setup__label" }, "Colors"),
                react_1.default.createElement(BrandColors_1.default, { brandStore: brandStore })),
            react_1.default.createElement("div", { id: "fonts-setup" },
                react_1.default.createElement(BrandFontsHeader_1.default, { brandStore: brandStore, fontService: fontService },
                    react_1.default.createElement("div", { className: "brand-setup__label" }, "Fonts")),
                react_1.default.createElement(BrandFonts_1.default, { brandStore: brandStore, fontService: fontService, usingFeature: usingFeature })),
            react_1.default.createElement("div", { id: "permissions-setup" },
                react_1.default.createElement("div", { className: "brand-setup__label" }, "Team Permissions"),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(StylePermissions_1.default, { usingFeature: usingFeature, explorePlans: explorePlans, stylePermissionStore: stylePermissionStore },
                        react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { fallback: react_1.default.createElement(react_1.default.Fragment, null), onError: function (error) {
                                (0, browser_1.captureException)(new Error("Error rendering style permissions preview"), {
                                    originalException: error,
                                });
                            } },
                            react_1.default.createElement(StylePermissionsPreview_1.default, { brandStore: brandStore, stylePermissionStore: stylePermissionStore }))))))));
};
exports.default = BrandSetup;
